// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"93672a17","266":"513238a7","449":"edf69eed"}[chunkId] + ".chunk.css";
};